'use client';
import { memo, PropsWithChildren } from 'react';

import StoreProvider from '@/store/StoreProvider';
import { NextUIProvider } from '@nextui-org/react';

interface IProps extends PropsWithChildren {}

const MainLayout: React.FC<IProps> = ({ children }) => {
	return (
		<StoreProvider>
			<NextUIProvider>{children}</NextUIProvider>
		</StoreProvider>
	);
};

export default memo(MainLayout);
